var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "popup",
      class: {
        "full-height": _vm.fullHeight,
        transparent: _vm.transparent,
      },
    },
    [
      _c("div", {
        staticClass: "popup-bg",
        on: {
          click: function ($event) {
            return _vm.closePopup($event, false)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "popup-inner", style: _vm.popupInnerStyle }, [
        _vm.type !== "intro" && !_vm.disableClose
          ? _c(
              "button",
              {
                staticClass: "popup-mobile-close",
                attrs: { "aria-label": _vm.$t("close") },
                on: {
                  click: function ($event) {
                    return _vm.closePopup($event, false)
                  },
                },
              },
              [_c("icon", { staticClass: "icon-close-info-white" })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "popup-iframe-container",
            class: {
              "fixed-height": _vm.type === "intro",
              "bg-white": _vm.isIframe,
            },
            style: _vm.popupContainerHeight,
          },
          [
            _c(
              "div",
              { staticClass: "info" },
              [
                _vm.favoritesMarkerTypes.includes(_vm.marker.type)
                  ? _c("i-favorite", {
                      attrs: { category: "marker", item: _vm.marker },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("i-tag-list", { attrs: { tags: _vm.markerCategory } }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.type !== "intro" && !_vm.disableClose
              ? _c(
                  "a",
                  {
                    attrs: { href: "javascript:" },
                    on: {
                      click: function ($event) {
                        return _vm.closePopup($event, false)
                      },
                    },
                  },
                  [_c("span", { staticClass: "popup-close" })]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm.isVideo
                ? _c(
                    "video",
                    {
                      ref: "video",
                      attrs: {
                        onloadstart: "this.volume = 0.6",
                        controlslist: "nodownload",
                        playsinline: "",
                        autoplay: "",
                        controls: "",
                        disablepictureinpicture: "",
                        disableremoteplayback: "",
                        "x-webkit-airplay": "deny",
                      },
                      domProps: { muted: _vm.type === "intro" },
                      on: {
                        play: function ($event) {
                          _vm.videoPlayed = true
                        },
                        ended: function ($event) {
                          return _vm.closePopup($event, true)
                        },
                        contextmenu: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c("source", {
                        attrs: { type: "video/mp4", src: _vm.url },
                      }),
                    ]
                  )
                : _vm.isImage
                ? _c("div", {
                    staticClass: "image",
                    style: { backgroundImage: `url('${_vm.url}')` },
                  })
                : _c("div", { staticClass: "iframe-wrapper" }, [
                    _c(
                      "iframe",
                      {
                        ref: "iframe",
                        staticClass: "embed-responsive-item",
                        attrs: {
                          src: _vm.iframeUrl,
                          frameborder: "0",
                          allowfullscreen: "",
                          allow: _vm.iframeAttrAllow,
                        },
                        on: { load: _vm.onIframeLoad },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("urlNoSupportIFrameError")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showIosUnmuteTip
                      ? _c(
                          "button",
                          {
                            ref: "iosAudioToggle",
                            staticClass: "ios-unmute-tip",
                            attrs: { type: "button" },
                            on: { click: _vm.handleIosUnmute },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.iosAudioButtonText) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.type === "intro"
        ? _c("div", { staticClass: "popup-action" }, [
            _c(
              "button",
              {
                class: { active: _vm.showAction },
                on: {
                  click: function ($event) {
                    return _vm.closePopup($event, true)
                  },
                },
              },
              [_vm._v("\n      " + _vm._s(_vm.actionText) + "\n    ")]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }